import {
  ChangeEvent,
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react'

import { Grid } from '@material-ui/core'
import * as Yup from 'yup'
import Input from 'shared/components/Input'
import ContainerPage from 'shared/components/ContainerPage'
import Form from 'shared/components/Form'
import { Content } from 'shared/components/Scaffold/styles'
import Scaffold from 'shared/components/Scaffold'
import { Icon } from 'shared/components/Icons/styles'
import { MdSearch } from 'react-icons/md'
import Button from 'shared/components/Button'
import { StyledFiltro, Title } from './style'

export default function FiltrosViagens({ getViagens, filtro, setFiltro }) {
  const [loading, setLoading] = useState(false)

  const handlePlaca = (event: ChangeEvent<HTMLInputElement>) => {
    setFiltro({ ...filtro, placa: event.target.value })
  }

  const handleCte = (event: ChangeEvent<HTMLInputElement>) => {
    setFiltro({ ...filtro, cte: event.target.value })
  }

  return (
    <StyledFiltro>
      <Grid container>
        <Grid item md={3}>
          <Title>Filtrar</Title>
        </Grid>
      </Grid>
      <Form
        enableReinitialize
        onSubmit={getViagens}
        initialValues={{
          placa: filtro?.placa,
          cte: filtro?.cte,
        }}
        validationSchema={() => ({
          placa: Yup.string(),
          cte: Yup.string(),
        })}
      >
        {formControl => (
          <Grid container xs={12} spacing={2}>
            <Grid item lg={4} xl={3}>
              <Input
                placeholder="Digite o número do CT-e"
                name="cte"
                formControl={formControl}
                errorMessage={''}
                onChange={handleCte}
                label={'CT-e'}
                type="number"
              />
            </Grid>
            <Grid item lg={4} xl={3}>
              <Input
                placeholder="Digite a placa"
                name="placa"
                formControl={formControl}
                errorMessage={''}
                onChange={handlePlaca}
                label={'Placa'}
              />
            </Grid>
            <Grid item lg={4} xl={3}>
              <div
                style={{ display: 'flex', alignItems: 'end', height: '100%' }}
              >
                <Button color={'green'} type="submit" onClick={getViagens}>
                  <MdSearch /> Buscar
                </Button>
              </div>
            </Grid>
          </Grid>
        )}
      </Form>
    </StyledFiltro>
  )
}
